import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
export var MainContent = styled.div.withConfig({
  displayName: "MainContent",
  componentId: "sc-1y2m7ze-0"
})(["flex-grow:1;max-width:", ";", " margin:0 auto;", " ", " ", " ", " ", ""], function (_ref) {
  var fullWidth = _ref.fullWidth,
    _ref$withSidebar = _ref.withSidebar,
    withSidebar = _ref$withSidebar === void 0 ? false : _ref$withSidebar,
    width = _ref.width;
  return width ? "".concat(width) : fullWidth ? '100%' : "".concat(grid(withSidebar ? 7 : 10), "px");
}, function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return !fullWidth && css(["", ";"], function (_ref3) {
    var theme = _ref3.theme,
      right = _ref3.right;
    return right ? "margin-left: ".concat(theme.columnGap, "px") : "margin-right: ".concat(theme.columnGap, "px");
  });
}, function (_ref4) {
  var noMargin = _ref4.noMargin;
  return !noMargin ? 'margin-bottom: 30px;' : null;
}, maxMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: ", ";\n  "])), function (_ref5) {
  var noMargin = _ref5.noMargin;
  return !noMargin ? '0 auto 30px' : '0 auto';
}), minMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref6) {
  var _ref6$withLargeSideba = _ref6.withLargeSidebar,
    withLargeSidebar = _ref6$withLargeSideba === void 0 ? false : _ref6$withLargeSideba;
  return withLargeSidebar && "max-width: ".concat(grid(5.5), "px;");
}), minMediaQueries.desktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref7) {
  var _ref7$withLargeSideba = _ref7.withLargeSidebar,
    withLargeSidebar = _ref7$withLargeSideba === void 0 ? false : _ref7$withLargeSideba;
  return withLargeSidebar && "max-width: ".concat(grid(6), "px;");
}), minMediaQueries.bigScreen(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref8) {
  var _ref8$withLargeSideba = _ref8.withLargeSidebar,
    withLargeSidebar = _ref8$withLargeSideba === void 0 ? false : _ref8$withLargeSideba;
  return withLargeSidebar && "max-width: ".concat(grid(7), "px;");
}));